import { ReactNode } from 'react'
import { Box, SwipeableDrawer, Typography, IconButton, Divider } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useTranslation } from 'react-i18next'

interface MobileSheetProps {
  open: boolean
  onClose: () => void
  onOpen: () => void
  title?: string
  children: ReactNode
}

export function MobileSheet({ open, onClose, onOpen, title, children }: MobileSheetProps) {
  const { t } = useTranslation()
  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      disableSwipeToOpen
      slotProps={{
        paper: {
          sx: {
            borderTopLeftRadius: 20,
            borderTopRightRadius: 20,
            // 80dvh, not 80vh — dvh tracks the dynamic viewport (excludes the
            // Safari URL bar) so the sheet doesn't jitter as the bar shows/hides.
            maxHeight: '80dvh',
          },
        },
      }}
    >
      {/* Drag handle */}
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 1 }}>
        <Box
          sx={{
            width: 40,
            height: 4,
            borderRadius: 2,
            bgcolor: 'text.secondary',
            opacity: 0.3,
          }}
        />
      </Box>

      {title && (
        <>
          <Box sx={{ px: 2, pb: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              {title}
            </Typography>
            <IconButton size="small" onClick={onClose} aria-label={t('common.close')}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
          <Divider />
        </>
      )}

      <Box
        sx={{
          px: 2,
          py: 1.5,
          // Clear the iOS home indicator so the last list item isn't hidden
          // behind the bottom safe-area gutter.
          pb: 'calc(12px + var(--safe-bottom, 0px))',
          overflowY: 'auto',
        }}
      >
        {children}
      </Box>
    </SwipeableDrawer>
  )
}
